import styles from "./DescriptionsTableB.module.css";
import clsx from "clsx";
import classes from "../../pages/Articles.module.css";

interface TableInterface {
  data: TableData;
  onParagraphClick: (url: string) => void;
  url: string;
}

interface TableData {
  rows: Array<any>;
  heading_1: any;
  heading_2: any;
  header?: string;
}

/* Component representing 2-row table */
const DescriptionTableB = ({ data, url, onParagraphClick }: TableInterface) => {
  const createListItem = (li: any, oneVideo: boolean) => {
    return (
      <li
        style={{
          backgroundColor: li.url === url ? "white" : undefined,
        }}
        className={clsx(classes.description, classes.li, [
          !oneVideo && classes.clickable,
        ])}
        onClick={() => !oneVideo && onParagraphClick(li.url)}
        dangerouslySetInnerHTML={{ __html: li.content }}
        key={li.url}
      />
    );
  };

  const createList = (list: any) => {
    const oneVideo = list.url !== "";
    const lis = list.children.map((li: any) => {
      if (li.type === "li") {
        return createListItem(li, oneVideo);
      } else if (li.type === "list") {
        return <li>{createList(li)}</li>;
      } else return <></>;
    });

    if (list.ordered)
      return (
        <ol
          className={clsx(oneVideo && classes.clickable)}
          onClick={() => oneVideo && onParagraphClick(list.url)}
          style={{
            backgroundColor: list.url === url ? "white" : undefined,
          }}
          key={list.url}
        >
          {lis}
        </ol>
      );

    return (
      <ul
        className={clsx(oneVideo && classes.clickable)}
        onClick={() => oneVideo && onParagraphClick(list.url)}
        style={{
          backgroundColor: list.url === url ? "white" : undefined,
        }}
        key={list.url}
      >
        {lis}
      </ul>
    );
  };

  const handleCell = (cell: any) => {
    return cell.map((c: any) => {
      if (c.type === "list") {
        return createList(c);
      } else {
        return (
          <div
            dangerouslySetInnerHTML={{ __html: c.content }}
            onClick={() => onParagraphClick(c.url)}
            style={{
              backgroundColor: c.url === url ? "white" : undefined,
            }}
            className={classes.clickable}
          />
        );
      }
    });
  };

  const tableHeader = (
    <>
      <thead>
        <th className={styles.thead}>{handleCell(data.heading_1)}</th>
        <th className={styles.thead}>{handleCell(data.heading_2)}</th>
      </thead>
    </>
  );

  const tableRows = data.rows.map((row) => {
    const { left, right } = row;
    return (
      <tr className={styles.tableRow}>
        <td className={styles.tableCell}>{handleCell(left)}</td>
        <td className={styles.tableCell}>{handleCell(right)}</td>
      </tr>
    );
  });

  const tableSmallHeader = data?.header !== undefined && (
    <div
      className={styles.thead}
      style={{ fontWeight: "bold", textAlign: "center", padding: "1rem" }}
    >
      {data.header}
    </div>
  );

  return (
    <>
      {tableSmallHeader}

      <table className={styles.table}>
        {tableHeader}
        <tbody>{tableRows}</tbody>
      </table>
    </>
  );
};

export default DescriptionTableB;
